import React, { useState } from "react";
import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import { Radio, RadioGroup } from "@mui/material";

// Import CSS files with correct relative paths and extensions
import "../assets/css/bootstrap.css";
import "../assets/css/fontawesome-all.css";
import "../assets/css/style.css";
import "../assets/css/custompg.css";
import "../assets/css/responsive.css";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import WhatsAppModal from "../components/MyWhatsAppModal";
import HomeIntro from "../components/HomeIntro";
import BoxImageSection from "../components/BoxImageSection";
import DefaultBanner from "../components/DefaultBanner";
import Ticker from "../components/Ticker";
import "../assets/css/PublicPageTheme.css";

const HomePage = () => {

  const [chatOpen, setChatOpen] = useState(false);

  const carouselItems = [
    { title: "Fashion", imagePath: require("../assets/images/header_icons/menu-1.png") },
    { title: "Electronics", imagePath: require("../assets/images/header_icons/menu-2.jpg") },
    { title: "Home Appliances", imagePath: require("../assets/images/header_icons/menu-3.jpg") },
    { title: "Repair", imagePath: require("../assets/images/header_icons/menu-4.jpg") },
    { title: "Carpenter", imagePath: require("../assets/images/header_icons/menu-5.jpg") },
    { title: "Grooming", imagePath: require("../assets/images/header_icons/menu-6.jpg") },
    { title: "Electronics", imagePath: require("../assets/images/header_icons/menu-7.png") },
    { title: "Travel", imagePath: require("../assets/images/header_icons/menu-8.jpg") },
    { title: "Vegetables", imagePath: require("../assets/images/header_icons/menu-9.jpg") },
    { title: "Grocery", imagePath: require("../assets/images/header_icons/menu-10.jpg") },
    { title: "Self jobs", imagePath: require("../assets/images/header_icons/menu-11.jpg") },
    { title: "Vehicle care", imagePath: require("../assets/images/header_icons/menu-12.jpg") },
    { title: "Food", imagePath: require("../assets/images/header_icons/menu-13.jpg") },
    { title: "RO services", imagePath: require("../assets/images/header_icons/menu-14.jpg") },
  ];
 
  const scrollMenuOwlOptions = {
    items: 10,
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    navText: [
      '<i class="fa fa-chevron-left"></i>',
      '<i class="fa fa-chevron-right"></i>',
    ],
    slideBy: 1,
    responsive: {
      0: { items: 3 },
      576: { items: 4 },
      768: { items: 6 },
      992: { items: 8 },
      1200: { items: 10 },
    },
  };

  return (
    <div className="public-page-theme home-page">
      <Ticker />
      <DefaultBanner />
      <Header />

      <div className="scrollmenu">
        <OwlCarousel
          className="owl-carousel"
          id="scroll_menu"
          {...scrollMenuOwlOptions}
        >
          {carouselItems.map((item, index) => (
            <div key={index} className="item">
              <a className="nav-link" href="#">
                <img
                  className="header_icons"
                  src={item.imagePath}
                  alt={item.title}
                />
                {item.title}
              </a>
            </div>
          ))}
        </OwlCarousel>
      </div>

      <BoxImageSection />
      <HomeIntro />
      <Footer />

      {/* Chatbase chat window */}
      {chatOpen && (
        <div className="chat-window-container">
          <button
            className="chat-window-close"
            onClick={() => setChatOpen(false)}
            aria-label="Close chat"
          >
            ✕
          </button>
          <iframe
            src="https://www.chatbase.co/chatbot-iframe/wCe5dubGyadtENWR-gL5_"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="Chat Agent"
          />
        </div>
      )}

      {/* Chat Agent floating button */}
      <button
        className="chat-agent-float"
        onClick={() => setChatOpen((prev) => !prev)}
        title="Chat with us"
        aria-label="Open chat agent"
      >
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM7 9h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"/>
        </svg>
      </button>

      <a
        href="https://wa.me/919296586850?text=Hi%20I%20want%20to%20know%20more%20about%20TrustApp"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
        />
      </a>

      <a
        href="https://play.google.com/store/apps/details?id=com.trustapp"
        className="download-app-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fas fa-download"></i>
        <span>Download App</span>
      </a>
    </div>
  );
};

export default HomePage;
